import React, { Component, ReactElement } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import PageContent from "@my-dld/components/PageContent";

import { Redirect } from "react-router";
import { extractPropInfo } from "../../component/PropertyHeader";
import EjariPageTitle from "../../component/EjariPageTitle";
import { replaceNavigate } from "@my-dld/utils/StoreUtils";
import { UpdateProperty } from "@eres/ejari-core/actions";
import { TenantContext } from "@eres/ejari-core/contexts/TenantContext";
import { getAppServices } from "@10x/coreapp/index";

interface Props extends RoutedViewProps {
	title: string;
	message: string;
	refreshProperty: boolean;
	buttonTitle: string;
	extra?: ReactElement;
	onNavigateBack?: () => boolean;
}

interface State {

}

class TenantActionSuccessPage extends Component<Props, State> {
	static contextType = TenantContext;
	context!: React.ContextType<typeof TenantContext>;

	constructor( props: Props ) {
		super( props );
		this.state = {
			loadState: "loading",
			errorContainer: {},
		};
	}

	componentDidMount() {
		if ( this.props.refreshProperty ) {
			UpdateProperty( getAppServices().storeService.getStore() );
		}
	}

	render() {
		const { property } = this.context;
		if ( property == null )
			return <Redirect to={ "/mydld" }/>;
		const { val, lbl } = extractPropInfo( property );
		return <PageContent title={ `${ this.props.title } - ${ lbl } : ${ val }` }>
			<EjariPageTitle title={ this.props.title }/>
			<React.Fragment>
				<div className="success-msg" id="successMsg" style={ { marginTop: "46px" } }>
					<div className="col-md-12 text-center">
						<div className="mb-3 d-flex justify-content-center green">
							<div className="svg-check-icon"/>
						</div>
						<p>{ this.props.message }</p>
						<br/>
						{ this.props.extra }
						<br/>
						<button
							onClick={ this.navigateBack }
							className="btn btn_1 btn_style1">{ this.props.buttonTitle }</button>
					</div>
				</div>
			</React.Fragment>
		</PageContent>;
	}

	private navigateBack = () => {
		replaceNavigate( "/mydld" );
		return;
	};
}

export default TenantActionSuccessPage;
